var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaginationContainer',_vm._g(_vm._b({},'PaginationContainer',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }